import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 12 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M7.5 17h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1M7.5 18h-3a.5.5 0 0 0 0 1H5a1 1 0 0 0 2 0h.5a.5.5 0 0 0 0-1M9.008 9.968l-.351 1.406L8 14H6.5V8h2a.499.499 0 1 0 0-1h-5a.5.5 0 0 0 0 1h2v6H4l-.657-2.626-.351-1.406a5 5 0 0 1-1.484-1.813A4.95 4.95 0 0 1 1 6c0-2.757 2.243-5 5-5s5 2.243 5 5c0 .775-.192 1.5-.508 2.155a5 5 0 0 1-1.484 1.813M6 0a6 6 0 0 0-6 6c0 1.828.82 3.463 2.11 4.563l.92 3.68A1 1 0 0 0 4 15h4a1 1 0 0 0 .97-.757l.92-3.68A5.98 5.98 0 0 0 12 6a6 6 0 0 0-6-6"
    }, null, -1)
  ]))]))
}
export default { render: render }